// src/pages/FulfillmentPage/utils/helpers.ts
import { Address, Fulfillment } from "../types";

export function formatPhone(phone?: string | null): string {
  if (!phone) return "N/A";
  const p = phone.replace(/\D/g, "");
  if (p.length === 10) return `${p.slice(0, 3)}-${p.slice(3, 6)}-${p.slice(6)}`;
  return phone;
}

export function safeJson(val: any): any {
  if (!val) return null;
  if (typeof val === "object") return val;
  try {
    return JSON.parse(val);
  } catch {
    return null;
  }
}

export function formatAttributes(attributes: any): string {
  if (!attributes) return "";
  const a = safeJson(attributes) ?? attributes;

  if (Array.isArray(a)) {
    return a
      .map((attr) => {
        const name = attr?.name ?? "";
        const values = Array.isArray(attr?.values) ? attr.values.join(", ") : attr?.values ?? "";
        return name ? `${name}: ${values}` : `${values}`;
      })
      .filter(Boolean)
      .join("\n");
  }

  if (typeof a === "object") {
    return Object.entries(a)
      .map(([k, v]) => `${k}: ${String(v)}`)
      .join("\n");
  }

  return String(a);
}

export function statusColor(status?: string): "default" | "warning" | "info" | "secondary" | "success" | "error" {
  const s = (status || "").toUpperCase();
  if (["NEW"].includes(s)) return "default";
  if (["PACKING"].includes(s)) return "warning";
  if (["READY"].includes(s)) return "info";
  if (["SHIPPED", "OUT_FOR_DELIVERY"].includes(s)) return "secondary";
  if (["DELIVERED"].includes(s)) return "success";
  if (["CANCELLED"].includes(s)) return "error";
  return "default";
}

export function extractAddress(fulfillment: Fulfillment | null): Address | null {
  if (!fulfillment) return null;
  
  const sa = safeJson(fulfillment.shipping_address) ?? fulfillment.shipping_address;
  const fullName = sa?.full_name || fulfillment.customer_name || "N/A";
  const line1 = sa?.address || fulfillment.shipping_address || "";
  const city = sa?.city || fulfillment.shipping_city || "";
  const state = sa?.state || fulfillment.shipping_state || "";
  const zip = sa?.zip_code || fulfillment.shipping_zip_code || "";
  const location = [city, state, zip].filter(Boolean).join(", ");

  return {
    fullName,
    line1,
    location,
    phone: formatPhone(sa?.phone || fulfillment.customer_phone),
    email: fulfillment.customer_email || "N/A",
  };
}